import React, { useState, useEffect } from 'react'
import { numberAddCommas, allowNumericOnly, isNumericOnly, numberClearCommas } from 'servos/formValidations'
import TrustPilot from '../../common/components/TrustPilot'

const ApplyNow = () => {
  const [loanPurpose, setLoanPurpose] = useState('refinance');
  const [loanAmount, setLoanAmount] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const handleChange = (e) => {
    setLoanAmount(numberAddCommas(e.target.value))
    if (isNumericOnly(numberClearCommas(loanAmount))) {
      setButtonDisabled(false)
    }
  }

  const handleApply = () => {
    const amount = numberClearCommas(loanAmount);
    if (isNumericOnly(amount)) {
      window.location.href = `/onboarding_funnel/new?loanPurpose=${loanPurpose}&loanAmount=${amount}`
    }
  }

  return (
    <div className="home-apply-now-container">
      <div className='apply-now-text'>I want to</div>
      <div className="btn-group btn-group-radio-tabs btn-group-toggle btn-group-lg d-flex w-100" data-toggle="buttons">
        <label 
          className="btn w-100 onboarding-form active"
          onClick={() => setLoanPurpose('refinance')}
        >
          <input id="refinance" autocomplete="off" checked="" name="options" type="radio"/>
          <b>Refinance</b>
        </label>
        <label 
          className="btn w-100 onboarding-form"
          onClick={() => setLoanPurpose('purchase')}
        >
          <input id="purchase" autocomplete="off" name="options" type="radio"/>
          <b>Purchase</b>
        </label>
      </div>

      <div className='apply-now-text'>How much would you like to borrow?</div>
    
      <div className="burrow-amount-container">
        <div className="input-group">
          <div className="input-group-prepend">
            <div className="input-group-text">$</div>
          </div>
          <input
            id='borrow-amount'
            value={loanAmount}
            className="form-control form-control-lg borrow-amount"
            placeholder="Enter amount"
            onChange={handleChange}
          />
          <button 
            className="btn btn-green home-apply-now-button" 
            disabled={buttonDisabled}
            onClick={handleApply}
            id="apply-now"
          >
            Apply now
          </button>
        </div>
      </div>

     <TrustPilot
       displayWidgetOnly='true'
       templateId='5419b732fbfb950b10de65e5' 
       height="34px"
     />
    </div>
  );
};

export default ApplyNow;
